const isDev = process.env.MODE === 'dev';
const inputLogin = isDev ? {
  email: '',
  pass: '',
} : {
  email: '',
  pass: '',
};

export { inputLogin };
